/*
 * Product page: gallery thumbnails and option pills → variant id + price.
 */
(function () {
  'use strict';

  /* ---------- Gallery ---------- */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-thumb');
        slides.forEach(function (slide) {
          slide.hidden = slide.getAttribute('data-slide') !== index;
        });
        thumbs.forEach(function (t) {
          if (t === thumb) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      });
    });
  });

  /* ---------- Variants ---------- */

  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('[data-product-json]');
  if (!form || !dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector('[data-variant-id]');
  var addButton = form.querySelector('[data-add]');
  var priceEl = document.querySelector('[data-price]');
  var addLabel = addButton ? addButton.textContent.trim() : '';
  var moneyFormat = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });

  function selectedOptions() {
    var picked = [];
    form.querySelectorAll('[data-option]:checked').forEach(function (input) {
      picked[Number(input.getAttribute('data-option')) - 1] = input.value;
    });
    return picked;
  }

  function update() {
    var picked = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.every(function (value, i) { return picked[i] === undefined || picked[i] === value; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) priceEl.textContent = moneyFormat.format(match.price / 100);
    if (addButton) {
      addButton.disabled = !match.available;
      addButton.textContent = match.available ? addLabel : addButton.getAttribute('data-sold-out') || addLabel;
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    history.replaceState(null, '', url);
  }

  form.querySelectorAll('[data-option]').forEach(function (input) {
    input.addEventListener('change', update);
  });
})();
